import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const Healthcare = () => {
  const solutions = [
    'Electronic Health Records (EHR)',
    'Patient Portal Development',
    'Telemedicine Platforms',
    'HIPAA Compliance Solutions',
    'Medical Billing Systems',
    'Healthcare Analytics'
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Healthcare Solutions</h1>
          <p>
            HIPAA-compliant software solutions for healthcare providers, hospitals, and medical practices
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Transforming Healthcare Delivery</h2>
            <p>
              We build secure, compliant healthcare software that improves patient care and streamlines
              operations. Our solutions integrate with existing systems and meet all regulatory requirements
              including HIPAA, HITECH, and HL7 standards.
            </p>
            <p>
              From electronic health records to telemedicine platforms, we help healthcare organizations
              leverage technology to deliver better patient outcomes while reducing costs.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header">
            <h2>Healthcare Solutions</h2>
            <p>Specialized software for the healthcare industry</p>
          </div>
          <div className="expertise-grid">
            {solutions.map((solution, index) => (
              <div key={index} className="expertise-item">
                {solution}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Modernize Your Healthcare Systems</h2>
            <p>Discuss your healthcare software requirements with our team.</p>
            <Link to="/contact">
              <Button 
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#2271b1',
                  color: '#ffffff',
                  fontWeight: '600',
                  padding: '14px 32px',
                  fontSize: '15px',
                  textTransform: 'none',
                  borderRadius: '3px',
                  boxShadow: '0 1px 0 #135e96',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#135e96',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }
                }}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Healthcare;
